document.addEventListener('DOMContentLoaded', function () {

    if (!document.querySelector('.LpHomeForm')) return;

    const voucherTypeSelect = document.querySelector('[data-voucher-type-select]');
    const voucherTypeCode = document.querySelector('[data-voucher-code]');
    const voucherTypeCodeInput = voucherTypeCode.querySelector('input');
    const voucherTypeImage = document.querySelector('[data-voucher-image]');
    const voucherTypeImageInput = voucherTypeImage.querySelector('input');
    const voucherTypeSelf = document.querySelector('[data-voucher-self]');
    const voucherTypeSelfInput = voucherTypeSelf.querySelector('input');

    voucherTypeSelect.addEventListener('change', function () {

        if (voucherTypeSelect.value === 'voucherImage') {
            // voucher type is set to Image
            // hide voucher code and self payer input, remove the required attribute
            // show image input, add it as required
            voucherTypeCode.classList.add('d-none');
            voucherTypeCodeInput.removeAttribute('required');
            voucherTypeSelf.classList.add('d-none');
            voucherTypeSelfInput.removeAttribute('required');
            voucherTypeImage.classList.remove('d-none');
            voucherTypeImageInput.setAttribute('required', true);
        }
        else if (voucherTypeSelect.value === 'voucherCode') {
            // voucher type is set to text
            // hide voucher image and self payer input, remove the required attribute
            // show text input, add it as required
            voucherTypeImage.classList.add('d-none');
            voucherTypeImageInput.removeAttribute('required');
            voucherTypeSelf.classList.add('d-none');
            voucherTypeSelfInput.removeAttribute('required');
            voucherTypeCode.classList.remove('d-none');
            voucherTypeCodeInput.setAttribute('required', true);
        }
        else {
            // voucher type is set to self payer
            // hide voucher image and code input, remove the required attribute
            // show self payer input, add it as required
            voucherTypeCode.classList.add('d-none');
            voucherTypeCodeInput.removeAttribute('required');
            voucherTypeImage.classList.add('d-none');
            voucherTypeImageInput.removeAttribute('required');
            voucherTypeSelf.classList.remove('d-none');
            voucherTypeSelfInput.setAttribute('required', true);
        }

    });

});